import { InfoBoxUI } from "./InfoBoxUI";

export const InfoBox = () => {
  return <InfoBoxUI />;
};
